import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { CallbackPage } from "@/auth/CallbackPage";
import { SilentRenewPage } from "@/auth/SilentRenewPage";
import { DocsShell } from "@/features/shell/DocsShell";
import { NotesPage } from "@/features/notes/NotesPage";
import { SuiteHome } from "@/features/home/SuiteHome";
import { homeConfig } from "@/features/home/homeConfig";

function ProtectedShell() {
    return (
        <ProtectedRoute>
            <DocsShell />
        </ProtectedRoute>
    );
}

// `/` used to be the editor, and Drive plus the sister apps still open
// documents with `/?fileId=…` — forward those to /edit, query intact.
function HomeRoute() {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    if (params.has("fileId") || params.has("openFile")) {
        return <Navigate to={`/edit${search}`} replace />;
    }
    return <SuiteHome config={homeConfig} />;
}

export function App() {
    return (
        <>
            <Routes>
                <Route path="/auth/callback" element={<CallbackPage />} />
                <Route path="/auth/silent-renew" element={<SilentRenewPage />} />
                <Route element={<ProtectedShell />}>
                    <Route path="/" element={<HomeRoute />} />
                    <Route path="/home" element={<Navigate to="/" replace />} />
                    <Route path="/edit" element={<NotesPage />} />
                </Route>
            </Routes>
            <AppCopyright />
        </>
    );
}

function AppCopyright() {
    // Subtle, theme-aware corner credit — no opaque white box (which looked out
    // of place, especially in dark mode). Muted text that recedes into either theme.
    // Not in the editor: it sat on top of the status bar's save state.
    const { pathname } = useLocation();
    if (pathname.startsWith("/edit")) return null;
    return (
        <div className="pointer-events-none fixed bottom-1 right-2.5 z-[9999] select-none text-[10px] leading-none text-muted-foreground/60">
            © {new Date().getFullYear()} Fowlguard INC
        </div>
    );
}
